import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";

export default function GoToAvailability() {
    const { t } = useTranslation("mediumIntegration");
    const navigate = useNavigate();
    const GoToAvailabilityHandler = () => {
        navigate('/availability')
    }
    return (
        <div className="confirm-delete-wrapper register-medium">
            <div data-backdrop="static" className="modal fade" id="gotoavailability" role="dialog">
                <div className="modal-dialog modal-dialog-preview">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="icon-pop">
                                <img src="images/Union-icon.png" alt="Union-icon" />
                            </div>
                            <h3>{t("gotoAvailability.title")}</h3>
                            <div className="confirm-btn-box">
                            <div
                                    className="register-medium-confirnation"
                                    data-dismiss="modal"
                                    
                                >
                                    {t("buttons.cancel")}
                                </div>
                                <div
                                    className="register-medium-confirnation"
                                    data-dismiss="modal"
                                    onClick={GoToAvailabilityHandler}
                                >
                                    {t("gotoAvailability.goTo")}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
